import { apiClient } from './_shared.js'

/**
 * Получить список активных камер для текущего пользователя на ПВЗ.
 * Политика RLS автоматически скроет ограниченные камеры, если к ним нет доступа.
 */
export async function getCameras(pvzId) {
  return await apiClient(`/cameras?pvzId=${pvzId}`) || []
}

/**
 * Получить все камеры (включая неактивные) для администрирования.
 */
export async function getAllCamerasForAdmin(pvzId) {
  return await apiClient(`/cameras/all?pvzId=${pvzId}`) || []
}

/**
 * Добавить новую камеру.
 */
export async function addCamera(pvzId, name, provider, embedUrl, restrictAccess = false) {
  return await apiClient('/cameras', {
    method: 'POST',
    body: JSON.stringify({
      pvz_id: pvzId,
      name,
      provider: provider || 'other',
      embed_url: embedUrl,
      restrict_access: restrictAccess
    })
  })
}

/**
 * Обновить параметры камеры.
 */
export async function updateCamera(cameraId, updates) {
  return await apiClient(`/cameras/${cameraId}`, {
    method: 'PUT',
    body: JSON.stringify(updates)
  })
}

/**
 * Удалить камеру.
 */
export async function deleteCamera(cameraId) {
  await apiClient(`/cameras/${cameraId}`, { method: 'DELETE' })
}

/**
 * Получить список индивидуальных доступов к камере.
 */
export async function getCameraAccessList(cameraId) {
  return await apiClient(`/cameras/${cameraId}/access`) || []
}

/**
 * Предоставить доступ к камере сотруднику.
 */
export async function grantCameraAccess(cameraId, employeeId, grantedBy) {
  return await apiClient(`/cameras/${cameraId}/access`, {
    method: 'POST',
    body: JSON.stringify({ employeeId })
  })
}

/**
 * Отозвать доступ к камере у сотрудника.
 */
export async function revokeCameraAccess(cameraId, employeeId) {
  await apiClient(`/cameras/${cameraId}/access/${employeeId}`, { method: 'DELETE' })
}
